import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b109d07a&scoped=true"
import script from "./askQuestionBlock.js?vue&type=script&lang=js&external"
export * from "./askQuestionBlock.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=b109d07a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b109d07a",
  null
  
)

export default component.exports